import { pileDePolice } from '../../lib/polices';
import { SOC } from '../../constants/company';
import { fmt } from '../../lib/currency';
import { today } from '../../lib/utils';
import { C } from '../../theme/palette';
import { PleinEcran } from '../../components/ui/PleinEcran.jsx';

export function RapportComptaA4({ data, soc, onClose }) {
  const d = data || {};
  const pr = () => {
    try {
      window.print();
    } catch (e) {}
  };
  const perLbl = d.periode === 's1' ? '1er semestre' : d.periode === 's2' ? '2e semestre' : 'Année';
  const an = new Date().getFullYear();
  const Row = ({ l, v, c, strong }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        borderBottom: '1px solid #eef1f4',
        fontSize: strong ? 11.5 : 10.5,
        fontWeight: strong ? 800 : 500,
        color: c || '#0f172a',
      }}
    >
      <span>{l}</span>
      <span style={{ fontWeight: strong ? 900 : 700 }}>{'CHF ' + fmt(v)}</span>
    </div>
  );
  const H2 = ({ t }) => (
    <div
      style={{
        fontSize: 11,
        fontWeight: 800,
        color: C.navy,
        marginTop: 15,
        marginBottom: 4,
        textTransform: 'uppercase',
        letterSpacing: 0.3,
      }}
    >
      {t}
    </div>
  );
  return (
    <PleinEcran>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          paddingTop: 'var(--st-haut)',
          zIndex: 9999,
          background: '#5b5f66',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <style>
          {
            '@media print{@page{size:A4;margin:12mm} body{visibility:hidden!important} #rapA4,#rapA4 *{visibility:visible!important} #rapA4{position:fixed;left:0;top:0;width:100%} .rapNoPrint{display:none!important}}'
          }
        </style>
        <div
          className="rapNoPrint"
          style={{
            background: C.red,
            padding: '10px 14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: 16,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            ‹ Retour
          </button>
          <div style={{ display: 'flex', gap: 7 }}>
            <button
              onClick={pr}
              style={{
                background: C.green,
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 12px',
                fontSize: 11.5,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              📄 PDF
            </button>
            <button
              onClick={pr}
              style={{
                background: 'rgba(255,255,255,.2)',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 12px',
                fontSize: 11.5,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              🖨 Imprimer
            </button>
            <a
              href={
                'mailto:?subject=' +
                encodeURIComponent('Récapitulatif comptable ' + perLbl + ' ' + an) +
                '&body=' +
                encodeURIComponent(
                  'Bonjour, veuillez trouver le récapitulatif comptable (' +
                    perLbl +
                    ' ' +
                    an +
                    '). Cordialement.',
                )
              }
              style={{
                background: 'rgba(255,255,255,.2)',
                color: '#fff',
                borderRadius: 8,
                padding: '8px 12px',
                fontSize: 11.5,
                fontWeight: 800,
                textDecoration: 'none',
              }}
            >
              📧 E-mail
            </a>
          </div>
        </div>
        <div
          className="rapNoPrint"
          style={{ fontSize: 9, color: '#e5e7eb', textAlign: 'center', padding: '6px 12px' }}
        >
          📱 « Imprimer / PDF » → Partager → « Enregistrer dans Fichiers ». · 💻 « Imprimer » → «
          Enregistrer en PDF ».
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '14px 10px' }}>
          <div
            id="rapA4"
            style={{
              maxWidth: 680,
              margin: '0 auto',
              background: '#fff',
              borderRadius: 4,
              padding: '26px 30px',
              color: '#0f172a',
              fontFamily: pileDePolice(soc && soc.docFont) || 'inherit',
            }}
          >
            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 16 }}>
              {soc && soc.logo ? <img src={soc.logo} alt="" style={{ maxHeight: 46 }} /> : null}
              <div>
                <div style={{ fontWeight: 800, fontSize: 13 }}>{(soc && soc.nom) || SOC.nom}</div>
                <div style={{ fontSize: 9.5, color: '#5a6270', lineHeight: 1.5 }}>
                  {(soc && soc.adr) || ''}
                  {soc && soc.npa ? ' · ' + soc.npa : ''}
                  {soc && soc.tva ? ' · ' + soc.tva : ''}
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 800,
                color: C.navy,
                borderBottom: '2px solid ' + C.navy,
                paddingBottom: 5,
                marginBottom: 6,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}
            >
              Récapitulatif comptable
            </div>
            <div style={{ fontSize: 10, color: '#5a6270', marginBottom: 2 }}>
              {perLbl + ' ' + an + ' · établi le ' + today()}
            </div>
            <H2 t="TVA" />
            <Row l="TVA facturée (encaissée)" v={d.tvaColP} c="#0F6B3A" />
            <Row l="TVA sur achats/frais (déductible)" v={d.tvaDedP} c="#C43736" />
            {d.tvaP >= 0 ? (
              <Row l="TVA à payer à l'AFC" v={d.tvaP} strong />
            ) : (
              <Row l="TVA à récupérer (crédit AFC)" v={-d.tvaP} c="#0F6B3A" strong />
            )}
            <H2 t="Salaires & charges sociales (part employeur)" />
            <Row l="Salaires bruts" v={d.salP} />
            <Row l="AVS / AI / APG" v={d.cAVS} />
            <Row l="AC (chômage)" v={d.cAC} />
            <Row l="LAA (accident)" v={d.cLAA} />
            {d.cMal > 0 ? <Row l="IJM (maladie)" v={d.cMal} /> : null}
            <Row l="LPP (2e pilier)" v={d.cLPP} />
            <Row l="Allocations familiales" v={d.cAF} />
            <Row l="Frais d'administration" v={d.cAdmin} />
            {d.cCanton > 0 ? <Row l="Cotisations du canton" v={d.cCanton} /> : null}
            {d.cCCT > 0 ? <Row l="CCT / Parifonds" v={d.cCCT} /> : null}
            {d.cRet > 0 ? <Row l="RETABAT" v={d.cRet} /> : null}
            <Row l="Total charges patronales" v={d.chSocP} c="#B7791F" strong />
            <H2 t="Dépenses par catégorie" />
            {(d.catsList || []).length === 0 ? (
              <div style={{ fontSize: 10, color: '#94a3b8', padding: '4px 0' }}>
                Aucune dépense sur la période.
              </div>
            ) : (
              (d.catsList || []).map((x, i) => <Row key={i} l={x[0]} v={x[1]} />)
            )}
            <Row l="Total dépenses" v={d.fraisP} c="#C43736" strong />
            <H2 t="Bénéfice & impôts" />
            <Row l="Chiffre d'affaires facturé (HT)" v={d.caP} c="#0F6B3A" />
            <Row l="= Bénéfice" v={d.benef} c={d.benef >= 0 ? '#0F6B3A' : '#C43736'} strong />
            {d.impots?.independant ? (
              <>
                <Row l="AVS / AI / APG indépendant" v={d.impots.avs} />
                <Row l="Impôt sur le revenu (estimation)" v={d.impots.revenu} />
              </>
            ) : (
              <>
                <Row l="Impôt société (estimation)" v={d.impot} />
                <Row l="Impôt sur le capital" v={d.impotCap} />
              </>
            )}
            <div
              style={{
                marginTop: 15,
                background: C.navy,
                color: '#fff',
                borderRadius: 10,
                padding: '12px 15px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span style={{ fontSize: 12, fontWeight: 800 }}>TOTAL À PAYER</span>
              <span style={{ fontSize: 18, fontWeight: 900 }}>{'CHF ' + fmt(d.totalDu)}</span>
            </div>
            <div
              style={{
                marginTop: 32,
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 30,
                position: 'relative',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                {soc && soc.sigPatron ? (
                  <img
                    src={soc.sigPatron}
                    alt=""
                    style={{ height: 40, display: 'block', margin: '0 auto' }}
                  />
                ) : (
                  <div style={{ height: 40 }} />
                )}
                <div
                  style={{
                    borderTop: '1px solid #0f172a',
                    paddingTop: 4,
                    fontSize: 9.5,
                    fontWeight: 700,
                  }}
                >
                  Signature
                  <br />
                  <span style={{ fontWeight: 400, color: '#5a6270' }}>
                    {(soc && soc.nom) || ''}
                  </span>
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ height: 40 }} />
                <div
                  style={{
                    borderTop: '1px solid #0f172a',
                    paddingTop: 4,
                    fontSize: 9.5,
                    fontWeight: 700,
                  }}
                >
                  Comptable / fiduciaire
                </div>
              </div>
              {soc && soc.tampon ? (
                <img
                  src={soc.tampon}
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 20,
                    bottom: 34,
                    width: 60,
                    height: 60,
                    objectFit: 'contain',
                    opacity: 0.85,
                    transform: 'rotate(-8deg)',
                  }}
                />
              ) : null}
            </div>
            <div style={{ fontSize: 8, color: '#94a3b8', marginTop: 18, textAlign: 'center' }}>
              {'Document généré par SwissTech le ' +
                today() +
                ' · Estimations à valider par la fiduciaire.'}
            </div>
          </div>
        </div>
      </div>
    </PleinEcran>
  );
}
